var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdlogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "375px",
    height: "362px",
    viewBox: "0 0 375 362",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "adlogo_bg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "admobilize-logo-(2)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "adlogo_bg"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#D31E41",
    points: "80.6 62.5 79.2 65.5 40.6 144 182.5 88.3 80.6 62.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#D31E41",
    points: "182.5 88.3 264.3 198 208.2 95.8 182.5 88.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#D31E41",
    points: "163.6 236.2 264.3 198 182.5 88.3 163.6 236.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#D31E41",
    points: "163.6 236.2 40.6 144 182.5 88.3 163.6 236.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#D31E41",
    points: "0.9 175.8 40.6 144 44.5 285.9 0.9 175.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#D31E41",
    points: "163.6 236.2 40.6 144 44.5 285.9 163.6 236.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#D31E41",
    points: "163.6 236.2 180 312.4 44.5 285.9 163.6 236.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#D31E41",
    points: "163.6 236.2 180 312.4 264.3 198 163.6 236.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#D31E41",
    points: "0.9 175.8 40.6 144 80.6 62.5 0.9 175.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#BF1129",
    points: "80.6 62.5 79.2 65.5 40.6 144 112.3 115.8 111.6 113.8 137.5 76.9 80.6 62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,167.6 L133.6,193.3 L139.7,184.7 L132.9,167.6 M122.1,140.5 L92.3,164.4 L102.7,190.6 L124.2,206.7 L132.6,194.7 L131.8,164.9 L122.1,140.5 M117.4,128.6 L94.2,161.6 L95.3,160.7 L121.7,139.5 L117.4,128.6 M112.3,115.8 L40.6,144 L101.2,189.4 L91.5,165 L89.3,166.8 L91.2,164.1 L91.2,164 L91.4,163.8 L117,127.4 L112.3,115.8",
    id: "Shape",
    fill: "#D01D41"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#C0112A",
    points: "40.6 144 0.9 175.8 44.5 285.9 40.6 144"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.7,190.6 L114.5,220.4 L124.2,206.7 L102.7,190.6 M40.6,144 L44.5,285.9 L122.8,253.2 L111.5,224.6 L113.8,221.401 L101.1,189.501 L40.6,144",
    id: "Shape",
    fill: "#CA193A"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#BF1128",
    points: "122.9 253.2 44.5 285.9 143.5 305.2 122.9 253.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#BB0E22",
    points: "80.6 62.5 0.9 175.8 40.6 144 80.6 62.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.1,56.5 L153.7,77 L151.9,80.6 L153.7,81.1 L156.6,80 L168.1,56.5 M171.7,51.5 L158,79.3 L206.5,60.3 L171.7,51.5 M191.3,0.5 L191.3,0.5 L156.6,71.2 L171.1,50.6 L171.3,50.3 L208.2,59.6 L293.2,26.2 L191.3,0.5",
    id: "Shape",
    fill: "#0861BE"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#840C3D",
    points: "151.9 80.6 151.2 82 153.8 81 151.9 80.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#012AA4",
    points: "293.1 26.3 374.9 136 318.8 33.8 293.1 26.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.6,92.7 L279.4,133.6 L293.1,137.1 L318.8,144.6 L324.6,155.1 L329.701,153.2 L301.501,115.4 L284.6,92.7 M286.1,80.9 L284.8,91.2 L330.7,152.7 L335.2,151 L298.7,84.5 L286.1,80.9 M293.1,26.3 L293.1,26.3 L286.2,80 L299.3,83.8 L336.1,150.8 L374.901,136.1 L293.1,26.3",
    id: "Shape",
    fill: "#085FBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.6,79.9 L153.7,81 L155.7,81.5 L156.6,79.9 M273.6,77.9 L266.9,130.4 L279.4,133.6 L284.6,92.7 L273.6,77.9 M274.6,77.6 L284.8,91.3 L286.1,81 L274.6,77.6 M272.7,77.4 L229.9,94.2 L211.5,101.4 L221,118.7 L266,130.1 L272.7,77.4 M206.5,60.3 L158,79.3 L156.8,81.7 L182.5,88.2 L208.2,95.7 L210.9,100.6 L271.6,76.7 L206.5,60.3 M293.1,26.3 L208.1,59.7 L272,75.9 L271.9,75.8 L272.8,76.1 L272.9,75.5 L273.4,76.2 L273.8,76 L273.7,76.4 L274.8,76.7 L274.7,76.7 L286.1,80 L293.1,26.3",
    id: "Shape",
    fill: "#0E8CD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.8,81.8 L155.2,85 L167.4,94.2 L182.4,88.3 L156.8,81.8 M153.8,81 L151.3,82 L154.5,84.4 L155.9,81.5 L153.8,81",
    id: "Shape",
    fill: "#871242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.4,101.5 L196.7,107.3 L201.7,114 L220.9,118.9 L211.4,101.5 M182.5,88.3 L196.1,106.5 L210.9,100.7 L208.2,95.8 L182.5,88.3",
    id: "Shape",
    fill: "#610209"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.7,107.3 L189,110.3 L191,111.8 L191.3,111.3 L201.7,113.9 L196.7,107.3 M182.5,88.3 L182.5,88.3 L180.5,104 L188,109.7 L196,106.5 L182.5,88.3",
    id: "Shape",
    fill: "#87113F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#A71F6A",
    points: "182.5 88.3 167.4 94.2 180.5 104 182.5 88.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.5,92.6 L146.7,102.4 L151.7,100.4 L151.5,92.6 M146,86.2 L111.6,113.8 L112.4,115.8 L130.1,108.9 L146,86.2 M151.2,82 L148.8,84 L131.7,108.2 L145.3,102.8 L151.4,90.3 L151.2,82",
    id: "Shape",
    fill: "#840D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.9,133.4 L132.8,167.6 L139.6,184.7 L153.5,165 L153.1,149.3 L131.9,133.4 M130.9,133.4 L122.1,140.5 L131.8,164.9 L130.9,133.4 M152.4,124.7 L132.4,132.6 L153,148.1 L152.4,124.7 M130,108.9 L112.3,115.8 L116.9,127.4 L130,108.9 M145.3,102.9 L131.7,108.3 L117.4,128.7 L121.7,139.6 L130.5,132.5 L130.3,132.3 L130.8,132.1 L130.8,131.4 L131.1,131.7 L132.5,128.8 L145.3,102.9 M151.7,100.4 L146.7,102.4 L132.4,131.5 L152.4,123.7 L151.7,100.4",
    id: "Shape",
    fill: "#A41661"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.2,85 L151.5,92.6 L151.7,100.4 L167.4,94.2 L155.2,85 M151.2,82 L151.4,90.4 L154.4,84.4 L151.2,82",
    id: "Shape",
    fill: "#861041"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,110.3 L179.2,114.1 L177,131.6 L191,111.7 L189,110.3 M180.5,104 L179.3,113.1 L188,109.7 L180.5,104",
    id: "Shape",
    fill: "#860F3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,149.3 L153.5,165 L160.6,155 L153.1,149.3 M179.2,114.2 L152.4,124.7 L153,148 L161.1,154.1 L176.9,131.7 L179.2,114.2 M167.4,94.2 L151.7,100.4 L152.3,123.7 L179.2,113.1 L180.4,104 L167.4,94.2",
    id: "Shape",
    fill: "#A61C67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.7,153.1 L324.6,155 L340.1,183.2 L346.1,175.1 L329.7,153.1 M335.2,151.1 L330.7,152.8 L346.7,174.3 L347.4,173.4 L335.2,151.1 M374.9,136 L336.1,150.7 L348,172.4 L374.9,136",
    id: "Shape",
    fill: "#0650B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.7,77 L151.3,80.4 L151.9,80.6 L153.7,77 M191.3,0.5 L137.6,76.9 L150.3,80.1 L156.6,71.2 L191.3,0.5",
    id: "Shape",
    fill: "#0755B9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.3,80.4 L148.8,84 L151.2,82 L151.9,80.5 L151.3,80.4 M137.5,76.9 L111.5,113.8 L145.9,86.2 L150.2,80.1 L137.5,76.9",
    id: "Shape",
    fill: "#830B3B"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F8120D",
    points: "154.1 186.9 151.2 192.8 154.3 191.6 154.1 186.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F50C08",
    points: "172.8 164.1 170.1 185.4 190.5 177.4 172.8 164.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F8170E",
    points: "167.3 160 154.1 186.9 154.3 191.6 170.1 185.4 172.8 164.1 167.3 160"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0F5185",
    points: "279.4 133.6 278.2 142.9 293.1 137.1 279.4 133.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.9,130.4 L264.6,148.2 L278.2,142.9 L279.4,133.6 L266.9,130.4 M220.9,118.8 L235.3,145.1 L248.2,154.8 L263.6,148.8 L266,130.3 L220.9,118.8",
    id: "Shape",
    fill: "#1A7CA8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#B90101",
    points: "201.6 114 211.6 127.3 235.3 145.1 220.9 118.8 201.6 114"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F50E08",
    points: "191.3 111.3 191.3 111.3 191 111.8 211.6 127.3 201.6 114 191.3 111.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#166A9F",
    points: "235.3 145.1 241.9 157.2 248.2 154.7 235.3 145.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#B50001",
    points: "211.6 127.3 235.7 159.6 241.9 157.2 235.3 145.1 211.6 127.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F50C08",
    points: "191 111.8 175.4 143.6 172.9 162.9 191.6 176.9 235.7 159.6 211.6 127.3 191 111.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F8170E",
    points: "175.4 143.6 167.8 159.1 172.9 162.9 175.4 143.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.3,191 L335.7,194.2 L342.2,202.9 L347.099,196.2 L344.3,191 M340.1,183.3 L333.901,191.7 L335.201,193.4 L343.901,190.1 L340.1,183.3",
    id: "Shape",
    fill: "#F03902"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0F2A7D",
    points: "293.1 137.1 310.5 160.4 324.6 155.1 318.8 144.6 293.1 137.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0B236F",
    points: "324.6 155.1 310.5 160.4 333.9 191.7 340.1 183.3 324.6 155.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F03902",
    points: "347.7 197.2 342.9 203.8 374.9 246.8 347.7 197.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F46A11",
    points: "335.8 194.2 330.5 196.2 290.6 250.3 278.9 248.1 274.2 285 284.7 281 342.3 203 335.8 194.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0F4F86",
    points: "283.1 215.5 278.9 248.1 290.6 250.3 283.1 215.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0B4277",
    points: "330.5 196.2 283.2 214.2 283.1 215.5 290.6 250.3 330.5 196.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F46A11",
    points: "333.9 191.7 331.6 194.8 335.1 193.4 333.9 191.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0F4E84",
    points: "293.1 137.1 293.1 137.1 289.1 168.6 310.5 160.4 293.1 137.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0B4277",
    points: "310.5 160.4 289.1 168.6 283.4 213.1 331.6 194.8 333.9 191.7 310.5 160.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F46A11",
    points: "342.9 203.8 286.4 280.4 374.9 246.8 342.9 203.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F7951D",
    points: "233.9 239.3 226.5 249.3 265.4 278.5 258 244 233.9 239.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB0E06",
    points: "224.8 237.5 215.8 241.2 226.5 249.3 233.9 239.3 224.8 237.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0F708C",
    points: "254 225.3 239.8 231.2 233.9 239.3 258 244 254 225.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#E80A0A",
    points: "239.8 231.2 224.8 237.5 233.9 239.3 239.8 231.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F7951D",
    points: "259.1 244.2 266.7 279.4 274.2 285 278.9 248.1 259.1 244.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0F708C",
    points: "282.8 214.3 254.9 224.9 259.1 244.2 278.9 248.1 283.1 215.5 282.8 214.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0B5D7E",
    points: "283.2 214.2 282.8 214.3 283.1 215.5 283.2 214.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB0E06",
    points: "205.9 233.8 214.9 240.5 223 237.1 205.9 233.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FA1916",
    points: "154.3 191.6 151.2 192.8 154.4 195.2 154.3 191.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F8110E",
    points: "190.5 177.4 170.1 185.4 167.5 205 179.3 213.8 217.7 197.8 190.5 177.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FA2017",
    points: "170.1 185.4 154.3 191.6 154.4 195.2 167.5 205 170.1 185.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0F708C",
    points: "247.8 220.4 241 229.6 253.3 224.5 247.8 220.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F80E0D",
    points: "217.7 197.8 179.3 213.8 193.8 224.8 233.6 209.7 217.7 197.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#E80A0A",
    points: "233.6 209.7 193.8 224.8 205.9 233.8 223 237.1 241 229.6 247.8 220.4 233.6 209.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0F6F8B",
    points: "293.1 137.1 278.2 142.9 274.2 174.2 289.1 168.6 293.1 137.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1BA0AC",
    points: "278.2 142.9 264.6 148.3 262.4 165.4 274.2 174.2 278.2 142.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1792A3",
    points: "262.4 165.4 260.6 179.9 274.2 174.2 262.4 165.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0F708C",
    points: "274.2 174.2 274.2 174.2 260.6 179.9 259.4 189 264.3 198 257 208 254.9 223.9 282.6 213.3 274.2 174.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#B40101",
    points: "259.4 189 259.1 191 264.3 198 259.4 189"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F80E0D",
    points: "259.1 191 257.9 200.4 264.3 198 259.1 191"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#E80A0A",
    points: "264.3 198 257.9 200.4 257 208 264.3 198"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0B5D7E",
    points: "289.1 168.6 274.2 174.2 282.6 213.3 283.4 213.1 289.1 168.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1BA0AC",
    points: "263.5 148.7 248.2 154.7 261.5 164.7 263.5 148.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1792A3",
    points: "248.2 154.7 241.9 157.2 255.6 182 259.5 180.3 261.5 164.7 248.2 154.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#B80102",
    points: "241.9 157.2 235.7 159.6 253.1 183 255.6 182 241.9 157.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F8110E",
    points: "235.7 159.6 191.6 176.9 218.8 197.3 253.1 183 235.7 159.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.7,209.7 L248.4,219.599 L253.9,223.7 L255.7,209.7 M259.5,180.3 L255.6,181.9 L258.6,187.4 L259.5,180.3",
    id: "Shape",
    fill: "#0F708C"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#B40101",
    points: "255.6 182 253.1 183 258.3 189.9 258.6 187.5 255.6 182"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F80E0D",
    points: "253.1 183 218.8 197.3 234.7 209.2 256.9 200.8 258.3 189.9 253.1 183"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#E80A0A",
    points: "256.9 200.8 234.7 209.2 248.4 219.6 255.7 209.7 256.9 200.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FA0E05",
    points: "153.3 267.3 137 274.1 153.6 277.3 153.3 267.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1809",
    points: "144.9 197.9 133.9 206.7 134.1 214.2 152.2 227.7 151.9 215.6 144.9 197.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1508",
    points: "134.1 214.2 135.1 248.1 152.6 240.8 152.2 227.7 134.1 214.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FA0E05",
    points: "152.6 240.8 135.1 248.1 135.8 273.6 153.3 266.3 152.6 240.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F8120D",
    points: "151.2 192.8 144.9 197.9 151.9 215.6 151.2 192.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1809",
    points: "133 207.4 129.2 210.5 133.1 213.4 133 207.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1508",
    points: "129.2 210.5 115.1 221.8 126.8 251.6 134.1 248.5 133.1 213.4 129.2 210.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FA0E05",
    points: "134.1 248.5 126.8 251.6 134.7 271.5 134.1 248.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F46D12",
    points: "143.5 305.2 155.2 334.7 154.4 307.4 143.5 305.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1508",
    points: "114.2 222.5 111.6 224.6 122.9 253.2 125.9 251.9 114.2 222.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FA0E05",
    points: "125.9 251.9 122.9 253.2 143.5 305.2 154.4 307.4 153.6 278.4 135.8 274.9 135.9 277.1 135 275 134.8 275 134.8 274.4 125.9 251.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F6871A",
    points: "226.5 249.3 199.2 286.3 248.2 295.8 267.5 287.8 265.4 278.5 226.5 249.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1208",
    points: "168.9 260.8 153.3 267.3 153.6 277.3 173.3 281.2 168.9 260.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB0C06",
    points: "215.8 241.2 168.9 260.8 173.3 281.2 199.2 286.3 226.5 249.3 215.8 241.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F6871A",
    points: "266.7 279.4 268.4 287.4 274.2 285 266.7 279.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1007",
    points: "164.9 225.8 163.6 236.2 182.2 229.2 164.9 225.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FC1E0D",
    points: "151.9 215.6 152.2 227.7 163.6 236.2 164.9 225.8 155.2 223.9 151.9 215.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FC1A0B",
    points: "152.2 227.7 152.6 240.8 163.6 236.2 152.2 227.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1208",
    points: "163.6 236.2 163.6 236.2 152.6 240.8 153.3 266.3 168.6 259.8 163.6 236.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB0C06",
    points: "182.2 229.2 163.6 236.2 168.6 259.8 214.9 240.5 205.9 233.8 182.2 229.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F91713",
    points: "151.2 192.8 151.9 215.6 155.2 223.9 154.4 195.2 151.2 192.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F70F0C",
    points: "167.5 205 165.7 219.5 179.3 213.8 167.5 205"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F91D15",
    points: "154.4 195.2 155.2 223.9 165.7 219.5 167.5 205 154.4 195.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F70C0B",
    points: "179.3 213.8 165.7 219.5 164.9 225.8 182.2 229.2 193.8 224.8 179.3 213.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F91613",
    points: "165.7 219.5 155.2 223.9 164.9 225.8 165.7 219.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#E70908",
    points: "193.8 224.8 182.2 229.2 205.9 233.8 193.8 224.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F6871A",
    points: "198.6 287.2 180 312.4 154.4 307.4 155.2 334.7 246.6 296.5 198.6 287.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1208",
    points: "153.6 278.4 154.4 307.4 180 312.4 173.5 282.3 153.6 278.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB0C06",
    points: "173.5 282.3 180 312.4 198.6 287.2 173.5 282.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.2,294.3 L271.3,300.901 L271.4,301.401 L271,301.3 L270.5,301.901 L270.3,301.1 L246.5,296.5 L155.1,334.7 L290.6,361.1 L276.2,294.3 M267.5,287.8 L248.3,295.8 L270.2,300.1 L267.5,287.8 M274.2,285 L274.2,285 L268.4,287.4 L271,299.5 L275.9,292.9 L274.2,285",
    id: "Shape",
    fill: "#F46B12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.7,281 L274.2,285 L275.9,292.9 L284.7,281 M374.9,246.8 L286.4,280.4 L276.2,294.3 L290.599,361.2 L374.9,246.8",
    id: "Shape",
    fill: "#F35C0D"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1607",
    points: "139.6 184.7 133.6 193.3 133.9 206.7 144.9 197.9 139.6 184.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F7100B",
    points: "153.5 165 139.6 184.7 144.9 197.9 151.2 192.8 154.1 186.9 153.5 165"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F7150C",
    points: "160.6 154.9 153.5 165 154.1 186.9 167.3 160 160.6 154.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1607",
    points: "132.6 194.7 124.2 206.7 129.2 210.5 133 207.4 132.6 194.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1306",
    points: "124.2 206.7 114.5 220.4 115.1 221.8 129.2 210.5 124.2 206.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F40C07",
    points: "191.3 111.3 190.9 111.8 191 111.8 191.3 111.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F40B07",
    points: "190.9 111.8 176.9 131.7 175.4 143.6 191 111.8 190.9 111.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#F7150C",
    points: "176.9 131.7 161.2 154.1 167.8 159.1 175.4 143.6 176.9 131.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FB1306",
    points: "113.8 221.4 111.6 224.6 114.2 222.5 113.8 221.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#10C2FF",
    points: "171.1 50.3 171 50.7 171 50.6 171.9 51.1 171.7 51.5 206.5 60.3 208.1 59.7 171.1 50.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1CFFFF",
    points: "208.1 59.7 206.5 60.3 271.6 76.8 272.5 76.4 272 75.8 208.1 59.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#10C2FF",
    points: "168.2 56.4 168.1 56.5 156.6 79.9 156.6 79.9 168.2 56.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1CFFFF",
    points: "156.6 79.9 156.6 79.9 155.8 81.5 155.8 81.5 156.6 79.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2484",
    points: "155.8 81.5 154.4 84.4 154.4 84.4 155.8 81.5 155.8 81.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1A7A",
    points: "151.5 90.4 145.3 102.9 145.3 102.9 151.5 90.4 151.5 90.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2CC2",
    points: "145.3 102.9 145.3 102.9 132.6 128.7 145.3 102.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2082",
    points: "154.4 84.4 151.5 90.4 151.5 90.4 154.4 84.4 154.4 84.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1CFFFF",
    points: "273.8 76.3 273.8 76.3 274.8 76.6 274.9 76.6 273.8 76.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1CFFFF",
    points: "229.8 94.3 211.4 101.5 211.4 101.5 229.8 94.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#C20412",
    points: "211.4 101.5 196.7 107.3 196.7 107.3 211.4 101.5 211.4 101.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF227E",
    points: "196.7 107.3 189 110.3 189 110.3 196.7 107.3 196.7 107.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2CC2",
    points: "152.4 124.7 132.4 132.5 152.4 124.7 152.4 124.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1E7C",
    points: "189 110.3 179.2 114.2 179.2 114.2 189 110.3 189 110.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF38CE",
    points: "179.2 114.2 152.4 124.7 152.4 124.7 179.2 114.2 179.2 114.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1CFFFF",
    points: "272 75.8 272 75.8 272.5 76.4 272.8 76.3 272.8 76 272 75.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "348 172.5 347.4 173.4 351.2 180.3 355.3 185.8 355.3 185.8 348 172.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#10BEFF",
    points: "286.2 79.9 286.1 80.9 298.7 84.6 335.2 151.1 336.1 150.7 299.3 83.7 286.2 79.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1CFFFF",
    points: "273.8 76.3 273.8 76.5 274.6 77.6 286.1 80.9 286.2 79.9 274.8 76.6 273.8 76.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0CA0FF",
    points: "336.1 150.7 335.2 151.1 347.4 173.4 348 172.5 336.1 150.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#10BEFF",
    points: "284.6 92.7 284.6 92.7 301.5 115.4 284.6 92.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1CFFFF",
    points: "273.6 77.9 273.6 77.9 284.6 92.7 284.6 92.7 273.6 77.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1CFFFF",
    points: "272.9 75.4 272.8 76 272.8 76.3 273.4 76 272.9 75.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "346.7 174.3 346.1 175.1 354.3 186.1 343.8 190.1 343.8 190.1 355.3 185.8 351.2 180.3 346.7 174.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#10BEFF",
    points: "284.8 91.3 284.6 92.7 301.5 115.4 329.7 153.1 330.7 152.8 284.8 91.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1CFFFF",
    points: "273.8 76.5 273.6 77.9 284.6 92.7 284.8 91.3 274.6 77.6 273.8 76.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0CA0FF",
    points: "330.7 152.8 329.7 153.1 346.1 175.1 346.7 174.3 330.7 152.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF7204",
    points: "343.8 190.1 335.1 193.4 335.1 193.4 343.8 190.1 343.8 190.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFD422",
    points: "335.1 193.4 331.6 194.8 331.6 194.8 335.1 193.4 335.1 193.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1684EE",
    points: "331.6 194.8 283.4 213.1 331.6 194.8 331.6 194.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1CFFFF",
    points: "272.7 77.4 272.7 77.4 265.9 130.2 265.9 130.2 272.7 77.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#34F8FF",
    points: "265.9 130.2 263.5 148.7 263.5 148.7 265.9 130.2 265.9 130.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#36FFFF",
    points: "263.5 148.7 263.5 148.7 261.5 164.7 261.5 164.7 263.5 148.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#2EFFFF",
    points: "261.5 164.7 259.5 180.3 259.5 180.3 261.5 164.7 261.5 164.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.7,209.6 L255.7,209.6 L253.9,223.701 L253.9,223.701 L255.7,209.6 M259.5,180.3 L259.5,180.3 L258.6,187.4 L258.6,187.4 L259.5,180.3",
    id: "Shape",
    fill: "#1EE0FF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF0202",
    points: "258.6 187.5 258.3 189.9 258.3 189.9 258.6 187.5 258.6 187.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1C1A",
    points: "258.3 189.9 256.9 200.8 256.9 200.8 258.3 189.9 258.3 189.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1414",
    points: "256.9 200.8 256.9 200.8 255.7 209.7 255.7 209.6 256.9 200.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.7,187.4 L344.3,191 L344.3,191 L353.7,187.4 L353.7,187.4 M355.7,186.4 L355.4,186.8 L355.9,186.6 L355.7,186.4",
    id: "Shape",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF7204",
    points: "344.3 191 335.8 194.2 344.3 191 344.3 191"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFD422",
    points: "335.8 194.2 330.5 196.2 330.5 196.2 335.8 194.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1684EE",
    points: "330.5 196.2 283.2 214.2 330.5 196.2 330.5 196.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1CFFFF",
    points: "273.9 75.9 273.4 76 272.8 76.3 272.5 76.4 271.6 76.8 210.9 100.6 211.4 101.5 229.8 94.3 272.7 77.4 265.9 130.2 266.9 130.4 273.6 77.9 273.6 77.9 273.8 76.5 273.8 76.3 273.8 76.3 273.9 75.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#C20412",
    points: "210.9 100.6 196.1 106.5 196.7 107.3 211.4 101.5 210.9 100.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF227E",
    points: "196.1 106.5 188 109.6 189 110.3 196.7 107.3 196.1 106.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2CC2",
    points: "152.4 123.6 132.4 131.5 132 132.3 153.1 148 153.1 148 132.4 132.5 152.4 124.7 152.4 123.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1E7C",
    points: "188 109.6 179.3 113 179.2 114.2 189 110.3 188 109.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,148 L153.1,148 L161.2,154.1 L161.2,154.1 L153.1,148 M179.3,113 L152.4,123.6 L152.4,124.7 L179.2,114.2 L179.3,113",
    id: "Shape",
    fill: "#FF38CE"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#34F8FF",
    points: "265.9 130.2 263.5 148.7 264.6 148.3 266.9 130.4 265.9 130.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1810",
    points: "172.9 162.9 172.9 162.9 191.6 176.9 191.6 176.9 172.9 162.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2E1C",
    points: "167.8 159.1 167.8 159.1 172.9 162.9 172.9 162.9 167.8 159.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#36FFFF",
    points: "264.6 148.3 263.5 148.7 261.5 164.7 262.4 165.4 264.6 148.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#2EFFFF",
    points: "261.5 164.7 259.5 180.3 260.6 179.9 262.4 165.4 261.5 164.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF221C",
    points: "191.6 176.9 191.6 176.9 218.8 197.3 218.8 197.3 191.6 176.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,208 L255.8,209.7 L254,223.8 L254,223.8 L248.5,219.7 L254.5,224.2 L255,224 L257,208 M260.6,179.9 L259.5,180.3 L258.6,187.4 L259.4,188.9 L260.6,179.9",
    id: "Shape",
    fill: "#1EE0FF"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF0202",
    points: "258.6 187.5 258.3 189.9 259.1 191 259.4 189 258.6 187.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.8,197.3 L218.8,197.3 L234.7,209.2 L218.8,197.3 M258.3,189.9 L256.9,200.9 L258,200.5 L259.2,191.1 L258.3,189.9",
    id: "Shape",
    fill: "#FF1C1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.7,209.2 L234.7,209.2 L248.5,219.5 L234.7,209.2 M257.9,200.4 L256.8,200.799 L255.7,209.599 L256.9,207.9 L257.9,200.4",
    id: "Shape",
    fill: "#FF1414"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2A18",
    points: "161.2 154.1 161.2 154.1 167.8 159.1 167.8 159.1 161.2 154.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2CC2",
    points: "130.9 132.1 130.4 132.3 130.6 132.4 130.9 132.2 130.9 132.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF3A82",
    points: "132.9 167.6 133.6 193.3 133.6 193.3 132.9 167.6 132.9 167.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2CC2",
    points: "131.9 133.4 132.9 167.6 132.9 167.6 131.9 133.4 131.9 133.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF3012",
    points: "133.9 206.7 133.9 206.7 134.1 214.2 134.1 214.2 133.9 206.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2A10",
    points: "134.1 214.2 135.1 248.1 135.1 248.1 134.1 214.2 134.1 214.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1C0A",
    points: "135.1 248.1 135.1 248.1 135.8 273.6 135.1 248.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2C0E",
    points: "133.6 193.3 133.6 193.3 133.9 206.7 133.9 206.7 133.6 193.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3,164.4 L92,164.6 L91.5,165 L101.2,189.4 L102.7,190.5 L92.3,164.4 M91.3,163.9 L91.1,164.1 L91.1,164.2 L91.3,163.9 M95.3,160.7 L94.2,161.6 L94.2,161.6 L95.3,160.7",
    id: "Shape",
    fill: "#FF3A82"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF3274",
    points: "101.2 189.4 113.8 221.4 114.5 220.4 102.7 190.6 101.2 189.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2A10",
    points: "115.1 221.8 114.2 222.5 125.9 251.9 126.8 251.6 115.1 221.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1C0A",
    points: "126.8 251.6 125.9 251.9 134.8 274.4 134.7 271.5 126.8 251.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF260C",
    points: "114.5 220.4 113.8 221.4 114.2 222.5 115.1 221.8 114.5 220.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1C0A",
    points: "135.4 274.8 135 275 135.9 277.1 135.8 274.9 135.4 274.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2CC2",
    points: "130.9 131.4 130.9 132.1 130.9 132.2 131 132.1 131.2 131.6 130.9 131.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF3A82",
    points: "131.8 164.9 132.6 194.7 133.6 193.3 132.9 167.6 131.8 164.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2CC2",
    points: "132 132.3 131.8 132.7 130.9 133.4 131.8 164.9 132.9 167.6 131.9 133.4 153.1 149.3 153.1 148 132 132.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF38CE",
    points: "153.1 148 153.1 149.3 160.6 154.9 161.2 154.1 153.1 148"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1810",
    points: "172.9 162.9 172.8 164.1 190.5 177.4 191.6 176.9 172.9 162.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2E1C",
    points: "167.8 159.1 167.3 160 172.8 164.1 172.9 162.9 167.8 159.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1C0C",
    points: "223 237.1 214.9 240.5 215.8 241.2 224.8 237.5 223 237.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF221C",
    points: "191.6 176.9 190.5 177.4 217.7 197.8 218.8 197.3 191.6 176.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1EE0FF",
    points: "248.4 219.6 247.8 220.4 253.3 224.5 241 229.6 239.8 231.2 254 225.3 253.8 224.7 254.3 224.6 253.8 224.7 253.7 224.3 254.4 224.1 248.4 219.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1C1A",
    points: "218.8 197.3 217.7 197.8 233.6 209.7 234.7 209.2 218.8 197.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,229.6 L223,237.1 L224.8,237.401 L239.9,231.1 L241,229.6 M234.7,209.2 L233.6,209.599 L247.9,220.299 L248.5,219.499 L234.7,209.2",
    id: "Shape",
    fill: "#FF1414"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF3012",
    points: "133.9 206.7 133 207.4 133.1 213.4 134.1 214.2 133.9 206.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2A10",
    points: "133.1 213.4 134.1 248.5 135.1 248.1 134.1 214.2 133.1 213.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1C0A",
    points: "135.1 248.1 134.1 248.5 134.7 271.5 134.8 274.4 134.8 275 135 275 135.4 274.8 135.2 274.8 135.4 273.8 137 274.1 153.3 267.3 153.3 266.3 135.8 273.6 135.1 248.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2410",
    points: "168.6 259.8 153.3 266.3 153.3 267.3 168.9 260.8 168.6 259.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF180C",
    points: "214.9 240.5 168.6 259.8 168.9 260.8 215.8 241.2 214.9 240.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2A18",
    points: "161.2 154.1 160.6 154.9 167.3 160 167.8 159.1 161.2 154.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2C0E",
    points: "133.6 193.3 132.6 194.7 133 207.4 133.9 206.7 133.6 193.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFFF3A",
    points: "259.1 244.2 266.7 279.4 266.7 279.4 259.1 244.2 259.1 244.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1EE0FF",
    points: "254.9 224.9 254.9 224.9 259.1 244.2 259.1 244.2 254.9 224.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFFF34",
    points: "266.7 279.4 268.4 287.4 268.4 287.4 266.7 279.4 266.7 279.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFD624",
    points: "268.4 287.4 268.4 287.4 271 299.6 268.4 287.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1C0A",
    points: "135.4 273.8 135.2 274.8 135.4 274.8 135.8 274.9 153.6 278.4 153.6 277.3 137 274.1 135.4 273.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFFF34",
    points: "199.2 286.3 198.6 287.2 246.6 296.5 248.2 295.8 199.2 286.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2410",
    points: "153.6 277.3 153.6 278.4 173.5 282.3 173.3 281.2 153.6 277.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF180C",
    points: "173.3 281.2 173.5 282.3 198.6 287.2 199.2 286.3 173.3 281.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.3,300.9 L271,301.3 L271.4,301.401 L271.3,300.9 M248.2,295.8 L246.5,296.5 L270.3,301.1 L270.1,300 L248.2,295.8",
    id: "Shape",
    fill: "#FFD624"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "356.5 185.3 355.3 185.8 355.3 185.8 343.8 190.1 344.3 191 353.7 187.4 347.2 196.2 347.7 197.2 355.4 186.8 355.7 186.4 356.5 185.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.2,196.2 L342.3,202.9 L342.901,203.7 L347.8,197.099 L347.2,196.2 M343.8,190.1 L335.1,193.4 L335.701,194.2 L344.301,191 L343.8,190.1",
    id: "Shape",
    fill: "#FF7204"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFD422",
    points: "335.1 193.4 331.6 194.8 330.5 196.2 335.8 194.2 335.1 193.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1684EE",
    points: "331.6 194.8 283.4 213.1 283.2 214.2 330.5 196.2 331.6 194.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFD422",
    points: "342.3 203 284.7 281 286.4 280.4 342.9 203.8 342.3 203"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFFF3A",
    points: "258 244 265.4 278.5 266.7 279.4 259.1 244.2 258 244"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1EE0FF",
    points: "282.6 213.3 254.9 223.9 254.4 224.1 253.7 224.3 253.8 224.7 254.3 224.6 253.8 224.7 254 225.3 258 244 259.1 244.2 254.9 224.9 282.8 214.3 282.6 213.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#16BAFC",
    points: "283.4 213.1 282.6 213.3 282.8 214.3 283.2 214.2 283.4 213.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFFF34",
    points: "265.4 278.5 267.5 287.8 268.4 287.4 266.7 279.4 265.4 278.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFD624",
    points: "268.4 287.4 267.5 287.8 270.1 300.1 270.3 301.2 270.5 301.9 271 301.3 271.3 300.9 276.2 294.3 275.9 293 271 299.6 268.4 287.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FFB81A",
    points: "286.4 280.4 284.7 281 275.9 293 276.2 294.3 286.4 280.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF3A82",
    points: "117 127.5 91.3 163.9 91.2 164.1 89.3 166.8 91.5 165 92 164.6 92.3 164.4 122.1 140.5 121.7 139.5 95.3 160.7 94.2 161.6 94.2 161.6 117.4 128.6 117 127.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#10C2FF",
    points: "171 50.6 171 50.7 156.5 71.2 153.7 77 168.1 56.5 168.2 56.4 156.6 79.9 158 79.3 171.7 51.5 171.9 51.1 171 50.6"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#1CFFFF",
    points: "158 79.3 156.6 79.9 155.8 81.5 156.8 81.8 158 79.3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2484",
    points: "155.8 81.5 154.4 84.4 155.2 85 156.8 81.8 155.8 81.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.5,90.4 L145.4,102.8 L146.8,102.3 L151.6,92.5 L151.5,90.4 M148.8,84 L146,86.2 L130,108.9 L131.7,108.2 L148.8,84",
    id: "Shape",
    fill: "#FF1A7A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.7,108.2 L130,108.9 L117,127.5 L117.4,128.6 L131.7,108.2 M146.7,102.3 L145.3,102.8 L132.6,128.7 L131.2,131.6 L131,132 L130.9,132.1 L130.6,132.3 L121.8,139.4 L122.2,140.4 L131,133.3 L131.9,132.6 L132.1,132.1 L132.5,131.3 L146.7,102.3",
    id: "Shape",
    fill: "#FF2CC2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF2082",
    points: "154.4 84.4 151.5 90.4 151.5 92.6 155.2 85 154.4 84.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#0EAAFF",
    points: "156.5 71.2 150.3 80.1 151.3 80.4 153.7 77 156.5 71.2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Shape",
    fill: "#FF1676",
    points: "150.3 80.1 146 86.2 148.8 84 151.3 80.4 150.3 80.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.4,136.8 C324.4,139.8 331.599,145.2 337.2,153 C341.599,159.4 344.7,166.3 346.3,173.7 C347.901,181.1 348.7,188.2 348.7,194.9 C348.7,211.9 345.3,226.3 338.5,238.1 C329.3,254 315,262 295.6,262 L240.4,262 L240.4,134 L295.6,134 C303.6,134.1 310.2,135.1 315.4,136.8 L315.4,136.8 Z M266.4,156.2 L266.4,239.7 L291.1,239.7 C303.701,239.7 312.5,233.5 317.5,221 C320.2,214.2 321.6,206 321.6,196.6 C321.6,183.6 319.6,173.6 315.5,166.6 C311.4,159.6 303.3,156.1 291.1,156.1 L266.4,156.1 L266.4,156.2 Z",
    id: "Shape-Copy-2",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape-Copy",
    fill: "#FFFFFF",
    points: "182.7 134.9 152.4 134.9 106.7 261.3 134.7 261.3 143.4 234.7 143.5 234.7 150.8 211.4 150.6 211.4 167.3 161 183.5 211.4 183.3 211.4 190.4 234.7 190.5 234.7 199 261.3 228 261.3"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdlogo);
export default __webpack_public_path__ + "static/media/adlogo.c975263df0737e151e3a949e7f9c3631.svg";
export { ForwardRef as ReactComponent };